var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{attrs:{"variant":"success","to":"create","append":true}},[(_vm.$screen.md && _vm.$screen.lg)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }